import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import classnames from 'classnames'
import ChatTeaser from '~/Common-Objects/UI/Chat/Teaser'
import Dialog from '~/Common-Objects/UI/Dialog'
import Icon from '~/Common-Objects/UI/Icon'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Paging from '~/Common-Objects/Paging'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import InboxDropdownMenu from './inboxDropdownMenu'
import InboxStatusDropdownMenu from './inboxStatusDropdownMenu'
import InboxFilterDropdownMenu from './InboxFilterDropdownMenu'
import NewConversationDialog from '../newConversationDialog'
import InboxButton from '../shared/inboxButton'
import Footer from './inboxLeftSideBarFooter'
import * as styles from './index.module.scss'
import axios from '../../../../../../data/http/axios'
import InfiniteScroll from 'react-infinite-scroller'
import i18n from '~/i18n'

export default function InboxLeftSidebar({
    inboxes,
    activeInbox,
    conversations,
    activeConversation,
    changeConversation,
    changeInbox,
    className,
    conversationsStatusFilter,
    conversationsOrder,
    changeFilters,
    conversationSearchText = '',
    conversationSearchAgent = 0,
    conversationsSearchChannel,
    doingWizard = false,
    createConversation = () => {},
    setAddingInbox = () => {},
    loadingConversations = false,
    userRole = null,
    aiEnabled = false,
    isLoading,
    hasMore,
    changingStatus = false,
    totalConversations = 0,
    currentConversationsPage = 0,
    changeConversationsPage = () => {},
    totalConversationsToShow = 0,
    changingPage = false,
    stats,
    ...rest
}) {
    const siteMaster = useSelector((state) => state.siteMaster)
    const [isSearching, setIsSearching] = useState(false)
    const [newConversationOpen, setNewConversationOpen] = useState(false)
    const [users, setUsers] = useState([])

    const classes = classnames(`inbox-left-sidebar ${siteMaster.hasBanner ? '__with-banner' : ''}`, className)
    const activeConversationId = activeConversation ? activeConversation.id : null

    const creatingConversation = (contactId, emailAddress) => {
        setNewConversationOpen(false)
        createConversation(contactId, emailAddress)
    }

    useEffect(() => {
        axios.get('/accountUser').then((res) => setUsers(res.data.AccountUsers))
    }, [])

    return (
        <>
            <section className={classes} {...rest}>
                <header className='inbox-left-sidebar__header' style={{ height: 'auto' }}>
                    {!isSearching ? (
                        <>
                            <InboxDropdownMenu
                                activeInbox={activeInbox}
                                inboxes={inboxes}
                                setAddingInbox={setAddingInbox}
                                changeInbox={changeInbox}
                                userRole={userRole}
                            />
                            <div className='inbox-left-sidebar__header-right'>
                                <InboxButton
                                    variant='ghost'
                                    size='s'
                                    iconOnly
                                    aria-label={doingWizard ? i18n.t('chat:inbox.pleaseAddAChannelFirst') : 'Search'}
                                    onClick={() => setIsSearching(true)}
                                    disabled={doingWizard}
                                >
                                    <Icon name='magnifier' />
                                </InboxButton>

                                <Dialog.Root open={newConversationOpen} onOpenChange={setNewConversationOpen}>
                                    <Dialog.Trigger asChild>
                                        <InboxButton
                                            disabled={doingWizard || userRole > 1}
                                            size='s'
                                            alt={i18n.t('chat:inbox.leftBar.newMessageAlt')}
                                            title={
                                                doingWizard
                                                    ? i18n.t('chat:inbox.pleaseAddAChannelFirst')
                                                    : i18n.t('chat:inbox.leftBar.newMessageAlt')
                                            }
                                        >
                                            {i18n.t('chat:inbox.leftBar.newMessage')}
                                        </InboxButton>
                                    </Dialog.Trigger>
                                    {newConversationOpen && (
                                        <NewConversationDialog
                                            createConversation={creatingConversation}
                                            activeInbox={activeInbox}
                                        />
                                    )}
                                </Dialog.Root>
                            </div>
                        </>
                    ) : (
                        <div className={'inbox-left-sidebar__search'}>
                            <div>
                                <TextInput
                                    className='inbox-left-sidebar__search_searchInput '
                                    autoFocus
                                    placeholder={i18n.t('chat:inbox.leftBar.search')}
                                    iconLeft={<Icons icon='magnifier' color='#000000' />}
                                    value={conversationSearchText}
                                    onChange={(e) => changeFilters(undefined, undefined, e.target.value, undefined)}
                                    iconRight={
                                        <button
                                            className={styles.closeSearchBtn}
                                            onClick={() => {
                                                setIsSearching(false)
                                                changeFilters(undefined, undefined, '', undefined)
                                            }}
                                        >
                                            <Icon name='cross-circle' />
                                        </button>
                                    }
                                />
                            </div>
                        </div>
                    )}
                </header>

                <div className='inbox-left-sidebar__filters'>
                    <InboxStatusDropdownMenu
                        activeInbox={activeInbox}
                        stats={stats}
                        conversationsStatusFilter={conversationsStatusFilter}
                        setConversationsStatusFilter={(val) => {
                            changeFilters(val, undefined, undefined, undefined)
                        }}
                        disabled={doingWizard || changingStatus}
                        title={doingWizard ? i18n.t('chat:inbox.pleaseAddAChannelFirst') : ''}
                        aiEnabled={aiEnabled}
                    />
                    <InboxFilterDropdownMenu
                        disabled={doingWizard}
                        users={users}
                        currentOrder={conversationsOrder}
                        currentFilterUser={conversationSearchAgent}
                        conversationsSearchChannel={conversationsSearchChannel}
                        changeFilters={changeFilters}
                        activeInbox={activeInbox}
                    />
                </div>

                <div className='inbox-left-sidebar__scroller'>
                    <h2 className='visually-hidden'>{i18n.t('chat:inbox.leftBar.chats')}</h2>

                    {loadingConversations && <LoadingIcons />}
                    {!loadingConversations && conversations.length === 0 && (
                        <>
                            <Paper className={styles.emptyState}>
                                <div className={styles.emptyStateTitle}>{i18n.t('chat:inbox.leftBar.empty')}</div>
                                <div className={styles.emptyStateDescription}>
                                    {i18n.t('chat:inbox.leftBar.emptySubheader')}
                                </div>
                            </Paper>
                        </>
                    )}
                    {!loadingConversations && !changingPage && conversations.length > 0 && (
                        <ul className='inbox-left-sidebar__chats-list faux-list'>
                            {conversations.map((conversation) => {
                                return (
                                    <li key={'conv_' + conversation.id}>
                                        <ChatTeaser
                                            AccountUserId={conversation.AccountUserId}
                                            AccountUser={users.find((user) => user.id === conversation.AccountUserId)}
                                            active={conversation.id === activeConversationId}
                                            conversation={conversation}
                                            onClick={() => {
                                                changeConversation(conversation.id)
                                            }}
                                        />
                                    </li>
                                )
                            })}
                        </ul>
                    )}
                </div>
                {totalConversations > totalConversationsToShow && (
                    <div className='inbox-left-sidebar__paging'>
                        <Paging
                            totalItems={totalConversations}
                            currentPage={currentConversationsPage}
                            pageSize={totalConversationsToShow}
                            pagesToShow={10}
                            loading={changingPage}
                            changePage={changeConversationsPage}
                        />
                    </div>
                )}
                <Footer inboxes={inboxes} userRole={userRole} activeInbox={activeInbox} />
            </section>
        </>
    )
}
